import React from "react"

const Minus = ({ ...props }) => {
  return (
    <svg  {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fillRule="evenodd" d="M30.888 15.73c.296 0 .556.111.778.333.223.223.334.483.334.78 0 .326-.111.6-.334.823a1.068 1.068 0 01-.778.334H1.158c-.327 0-.601-.112-.824-.334A1.122 1.122 0 010 16.842c0-.296.112-.556.334-.779.223-.222.497-.333.824-.333h29.73z"></path></svg>
  )
}

export default Minus